var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _rect9, _rect0, _rect1, _g2, _rect10, _rect11, _mask, _g3, _mask2, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBgParts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 491,
    viewBox: "0 0 676 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.9258,
    height: 26.7576,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 127.088 173.333)",
    fill: "#EDE7F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9267,
    height: 24.7709,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 128.809 174.327)",
    fill: "#B39DDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26.9258,
    height: 26.7576,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 502.744 200.299)",
    fill: "#EDE7F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9267,
    height: 24.7709,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 504.465 201.292)",
    fill: "#B39DDB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 26.998,
    height: 26.8293,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 361.873 309.126)",
    fill: "#E3F2FD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 24.2748,
    height: 24.1231,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 364.249 310.115)",
    fill: "#90CAF9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 26.998,
    height: 26.8293,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 291.67 105.491)",
    fill: "#E3F2FD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 24.2748,
    height: 24.1231,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 294.046 106.48)",
    fill: "#90CAF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.758 240.075L123.458 237.015V244.082L123.468 244.076C123.522 244.528 123.849 244.97 124.447 245.316L175.094 274.555C176.41 275.315 178.545 275.315 179.861 274.555L226.735 247.494C227.438 247.088 227.765 246.548 227.717 246.016V239.107L222.346 242.208L176.087 215.503C174.771 214.743 172.637 214.743 171.32 215.503L128.758 240.075Z",
    fill: "url(#paint0_linear)"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 59.6284,
    height: 63.9858,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 122.063 237.059)",
    fill: "#90CAF9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 59.6284,
    height: 63.9858,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 122.063 237.059)",
    fill: "url(#paint1_linear)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 56.6816,
    height: 60.8238,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 124.708 237.113)",
    fill: "url(#paint2_linear)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.022 314.444V311.545H455.307V317.696L455.316 317.701C455.335 318.348 455.773 318.993 456.629 319.487L494.94 341.604C496.691 342.615 499.53 342.615 501.282 341.604L595.342 287.302C596.177 286.82 596.614 286.196 596.653 285.564L596.654 285.564V285.551C596.656 285.499 596.656 285.447 596.654 285.395L596.66 279.207L591.363 281.344L557.031 261.524C555.28 260.513 552.441 260.513 550.69 261.524L459.022 314.444Z",
    fill: "url(#paint3_linear)"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.5596,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 453.457 311.555)",
    fill: "#673AB7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.5596,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 453.457 311.555)",
    fill: "url(#paint4_linear)",
    fillOpacity: 0.3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 455,
    y: 255,
    width: 141,
    height: 81
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.5596,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 453.457 311.555)",
    fill: "#673AB7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 455,
    y: 255,
    width: 141,
    height: 81
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.5596,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 453.457 311.555)",
    fill: "#673AB7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.3732,
    height: 64.3732,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 502.602 258.472)",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 0.866041,
    width: 63.3732,
    height: 63.3732,
    rx: 4.5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 470.483 264.702)",
    stroke: "#5E35B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 59.4575,
    y: 214.933,
    width: 232.264,
    height: 208.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 391.307,
    y: 260.766,
    width: 269.353,
    height: 229.597,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.227451 0 0 0 0 0.717647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 175.59,
    y1: 234.035,
    x2: 123.458,
    y2: 245.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.503035,
    y1: 2.68177,
    x2: 20.3032,
    y2: 42.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91CBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -18.5494,
    y1: -44.8799,
    x2: 14.7845,
    y2: 40.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91CBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 591.644,
    y1: 279.231,
    x2: 462.328,
    y2: 334.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A491C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C5F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 8.1531,
    y1: -0.145767,
    x2: 57.1962,
    y2: 72.3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgParts);
export default __webpack_public_path__ + "static/media/img-bg-parts.b38567e01dcabd738bcabd3af1c0593b.svg";
export { ForwardRef as ReactComponent };